var _g, _circle, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanRightsAbuses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 615,
    viewBox: "0 0 615 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_118)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1004_118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.241 440.734C477.155 422.71 473.372 405.353 469.444 387.498C453.146 393.195 437.685 398.427 421.386 404.123C424.501 421.787 427.64 438.794 430.925 456.299C447.867 450.952 464.469 445.922 481.241 440.734Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.328 470.798C355.546 439.852 352.728 409.89 349.921 379.6C334.96 380.253 320.825 380.77 305.864 381.423C305.549 411.774 305.102 441.3 304.764 467.875C323.113 468.811 340.478 469.714 358.328 470.798Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.64 462.458C420.077 443.631 416.647 425.629 413.083 406.802C400.793 410.662 389.012 414.046 377.22 417.758C373.058 406.132 369.043 395.004 365.027 383.875C362.21 384.602 360.388 385.034 357.243 385.751C361.07 415.09 364.581 444.09 368.068 473.746C386.758 469.934 404.95 466.27 423.64 462.458Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.309 381.501C286.833 381.121 276.014 380.762 264.538 380.382C261.395 407.357 258.29 433.348 255.171 459.667C269.391 461.287 282.942 463.213 296.834 464.822C297.561 436.619 297.922 409.388 298.309 381.501Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.145 239.026C131.212 249.929 145.633 263.7 157.372 274.592C172.292 288.215 187.054 301.669 201.633 315.609C203.539 317.314 205.08 319.99 205.808 322.476C210.89 340.205 216.627 357.955 220.385 375.968C224.701 396.625 233.717 414.484 246.074 430.812C247.166 432.326 248.416 434.008 250.273 437.024C251.654 413.273 252.815 390.992 253.831 368.214C268.72 365.096 283.439 362.138 298.656 359.031C289.97 336.752 281.598 314.812 273.215 293.199C273.555 292.882 273.725 292.724 274.065 292.407C278.508 296.493 282.794 300.409 287.237 304.495C300.384 317.239 313.701 329.825 326.677 342.727C330.004 345.956 332.76 346.867 337.424 345.053C358.216 337.7 379.166 330.516 400.116 323.333C402.108 322.742 404.1 322.152 406.76 321.255C408.918 329.368 410.931 336.984 412.434 345.076C412.713 346.398 410.648 348.955 409.129 350.054C402.072 354.415 394.542 358.268 387.157 362.619C384.473 364.171 382.578 366.57 380.355 368.958C374.876 375.013 374.145 381.389 376.656 388.858C378.888 395.004 379.784 401.762 381.506 408.384C383.328 407.952 384.98 407.678 386.473 407.235C413.569 398.122 440.664 389.009 467.602 379.726C476.747 376.582 478.315 374.172 476.848 365.098C472.948 337.725 469.375 310.364 464.309 283.446C462.394 273.207 455.475 265.101 444.401 262.764C403.007 254.829 361.442 247.051 319.865 239.602C315.142 238.625 311.924 236.877 309.291 232.687C287.068 199.292 264.505 166.215 242.112 132.978C240.862 131.296 239.952 129.296 238.714 127.286",
    fill: "#FCFCFC"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 307.5,
    cy: 307.5,
    r: 293.5,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 103.636,
    y1: 83.8366,
    x2: 532.04,
    y2: 512.241,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white",
    transform: "translate(108 108)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1004_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 422,
    height: 422,
    fill: "white",
    transform: "translate(108 102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanRightsAbuses);
export default __webpack_public_path__ + "static/media/human-rights-abuses.b854822e6b68b9c9f14c2feea5ec6bf7.svg";
export { ForwardRef as ReactComponent };